import { CoverpathTermQuote } from './coverpath/CoverpathTermQuote';
import { CoverpathWholeLifeQuote } from './coverpath/CoverpathWholeLifeQuote';
import { MMDirectQuote } from './mm-direct/MMDirectQuote';
import { CoverpathAnnuityQuote } from './coverpath/CoverpathAnnuityQuote';
export const QuoteMap = {
  coverpathTermQuote: CoverpathTermQuote,
  coverpathWholeLifeQuote: CoverpathWholeLifeQuote,
  coverpathClientQuote: CoverpathTermQuote,
  mmDirectQuote: MMDirectQuote,
  coverpathAnnuityQuote: CoverpathAnnuityQuote,
};
